export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://www.hsmail.vip";

export default {
  LOGIN: "/Login/Login", //登录
  GETLOGINCODE: "/Login/Telms", //获取验证码
  GETTREND: "/Instrumentpanel/NumberOfMessagesSent", //获取趋势数据
  GETUSERS: "/User/GetUserList", //获取用户列表
  ADDUSER: "/User/RegistUser", //新增用户
  DELETEUSER: "/User/DelUser", //删除用户
  MODIFYUSER: "/User/UpdateUser", //修改用户
  SHOWUSER: "/User/GetUser", //查看某个用户
  SENDMESSAGE: "/api/External/send_kf_2", //发送消息，联系信息

  ADDEMAIL: "/emailsmtptable/Addemailsmtp", //增加邮箱
  MODIFYEMAIL: "/emailsmtptable/Updateemailsmtp",
  SHOWEMAIL: "/emailsmtptable/Getemailsmtp",
  GETEMAILLIST: "/emailsmtptable/GetEmailsmtpList", //邮箱列表
  DELETEEMALI: "/emailsmtptable/DeleteEmailsmtp",
  ADDMANYEMAIL: "/emailsmtptable/AddemailsmtpListString", //批量增加邮箱字符串

  ADDPROXY: "/ProxyService/AddProxy",
  MODIFYPROXY: "/ProxyService/UpdateProxy",
  GETPROXY: "/ProxyService/GetProxy",
  GETPROXYLIST: "/ProxyService/GetProxyList",
  DELETPROXY: "/ProxyService/DelProxy",
  ADDMANYPROXY: "/ProxyService/AddProxyListString", //批量增加代理

  //白名单
  GETWHITELIST: "/Whitelist/GetWhitelistList",
  ADDWHITE: "/Whitelist/AddWhitelist",
  MODIFYWHITE: "/Whitelist/UpdateWhitelist",
  GETWHITEBYID: "/Whitelist/GetWhitelist",
  DELETEWHITE: "/Whitelist/DelWhitelist",

  //模版
  ADDMODEL: "/EmailTemplate/AddTemplate",
  MODIFYMODEL: "/EmailTemplate/UpdateTemplate",
  GETMODELBYID: "/EmailTemplate/GetTemplate",
  GETMODELLIST: "/EmailTemplate/GetTemplateList", //前后台都有使用，需要根据type分权限
  DELETEMODEL: "/EmailTemplate/DeleteTemplate",
  MODIFYMODELSTATUS: "/EmailTemplate/UpdateTemplatestatus", //修改模版状态
  PREVIEWMODEL: "/EmailTemplate/PreviewTemplate", //预览模版-用户前台使用
  GETMODELLISTNO: "/EmailTemplate/GetTemplateListN", //不分页获取模版列表

  //邮件
  SENDEMAIL: "/api/Email/SingleEmailSend", //发送邮件
  CHECKSENDEMAIL: "/api/Email/SingleEmailSendJianCe", //检测发送邮件

  //外部用户接口
  GETFILELIST: "/api/External/GetTemplateList", //不分页模版列表
  SENDEMAILONLINE: "/api/External/SingleEmailSend", //线上发送邮件接口
};
